/**
 * CSS for links on colored (primary/secondary) backgrounds: keep the
 * surrounding text color and show an underline only. `!important` is needed
 * to beat the runtime's injected `[data-vibesite-richtext] a` hyperlink /
 * link-hover color rules and `[&_a]:text-primary` utilities.
 *
 * Pass a selector whose descendant anchors are content links (e.g.
 * `.my-section [data-vibesite-richtext]`), never one that also wraps CTA
 * buttons.
 */
export function onColorLinksCss(scope: string): string {
  return `
    ${scope} a,
    ${scope} a:hover,
    ${scope} a:visited {
      color: inherit !important;
      text-decoration-line: underline !important;
    }
  `;
}
